import { jsx as _jsx } from "react/jsx-runtime";
import { contract } from '@aviv_price-pages/brand';
import { useNavigate } from '@aviv-unified-frontend/runtime/router';
import { Box } from '@gemini/core';
import { Error404Illu } from '@/assets/icons/Error404Illu';
import ErrorContent from '@/components/ErrorContent';
import { TrackingViewPropsError } from '@/entities/enums/Tracking';
import { useShellTranslation } from '@/hooks/useShellTranslation/useShellTranslation';
import { useThorPageView } from '@/hooks/useThorPageView/useThorPageView';
export const Custom404 = () => {
    const { t } = useShellTranslation();
    const navigate = useNavigate();
    useThorPageView(TrackingViewPropsError.ERROR_404);
    return (_jsx(Box, { width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "spacing.56", children: _jsx(ErrorContent, { title: t('404_error_page.h1'), description: `${t('404_error_page.general_explanation')} ${t('404_error_page.advice')}`, image: Error404Illu, startButtonProps: {
                label: t('404_error_page.link_to_price_pages'),
                action: () => {
                    navigate(`${contract.basePath}${contract.mainCountryPagePath}`);
                    window.location.reload();
                },
            }, endButtonProps: {
                label: t('404_error_page.link_to_homepage'),
                action: () => navigate('/'),
            } }) }));
};
